export default "/_next/static/images/8038b8b53dc012f241ba8978b4f40332.png";